import {
    IsArray,
    IsBoolean,
    IsDateString,
    IsNotEmpty,
    IsNumber,
    IsString,
} from "class-validator";

export class EntityApiKeyDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsNumber()
    @IsNotEmpty()
    entity!: number;

    @IsString()
    name!: string;

    @IsString()
    @IsNotEmpty()
    prefix!: string;

    @IsArray()
    scopes!: string[];

    @IsBoolean()
    is_active!: boolean;

    @IsDateString()
    @IsNotEmpty()
    created!: string;

    @IsDateString()
    @IsNotEmpty()
    modified!: string;
}

export class EntityApiKeyCreatedDto extends EntityApiKeyDto {
    @IsString()
    @IsNotEmpty()
    plaintext_key!: string;
}
